export default {
  "nav.home": "Home",
  "nav.guide": "Shopping Guide",
  "nav.browse": "Browse Categories",
  "brand.tagline": "USFans Spreadsheet Resource",
  "brand.subtag": "Independent Resource",

  "cta.spreadsheet": "USFans Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "cta.explore": "Explore USFans Spreadsheet",
  "cta.browse": "Browse Categories",
  "cta.main": "Continue to Main Website",

  "dropdown.label": "Jump to a category",
  "dropdown.placeholder": "Choose a category…",

  "category.shoes": "Shoes",
  "category.hoodies": "Hoodies/Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants": "Pants/Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear/Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "Other Stuff",

  "categoryDesc.shoes": "Sneakers, casual & sport footwear.",
  "categoryDesc.hoodies": "Pullovers, zip-ups & warm layers.",
  "categoryDesc.tshirts": "Short & long sleeve everyday tops.",
  "categoryDesc.jackets": "Outerwear for every season.",
  "categoryDesc.pants": "Jeans, chinos & shorts.",
  "categoryDesc.headwear": "Caps, hats & beanies.",
  "categoryDesc.sets": "Matching coordinated outfits.",
  "categoryDesc.underwear": "Base layers, briefs & essentials.",
  "categoryDesc.jersey": "Sports & team jerseys.",
  "categoryDesc.accessories": "Watches & small add-ons.",
  "categoryDesc.bags": "Backpacks, handbags & totes.",
  "categoryDesc.belts": "Leather & casual belts.",
  "categoryDesc.perfumes": "Fragrances for men & women.",
  "categoryDesc.other": "Miscellaneous & new arrivals.",

  "footer.about": "usfanslink.lol is an independent informational resource about the USFans Spreadsheet. We are not affiliated with USFans.",
  "footer.disclaimer": "Disclaimer",
  "footer.disclaimerText": "This site is an independent informational resource and is not necessarily affiliated with USFans.",
  "footer.quickLinks": "Quick Links",
  "footer.rights": "All rights reserved.",
};